module.exports = __webpack_public_path__ + "static/media/thirdBanner.880463d1.jpg";